import { useEffect, useMemo, useState } from 'react'
import { getItemOrFirstEntry } from '@/utils/array-utils'
import { logger } from '@/utils/logging'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'
import { ShowtimesVenue } from './useVenueSearch/useVenueSearch'

interface Props {
  venues: ShowtimesVenue[]
}
export const useFindQueryVenue = ({ venues }: Props) => {
  const { isReady, query } = useSafeRouter()
  const [venue, setVenue] = useState<ShowtimesVenue | undefined>()

  useEffect(() => {
    try {
      if (!isReady) return
      if (!venues || venues.length === 0) return

      const venueId = getItemOrFirstEntry(query?.selectedVenue)
      if (!venueId) return

      const venue = venues.find((v) => v.id === venueId)
      if (venue) setVenue(venue)
    } catch (err) {
      logger().error('An error occurred while attempting to extract the venue from the query params', err)
    }
  }, [isReady, query, venues])

  return useMemo(() => {
    return { venue }
  }, [venue])
}
